// extracted by mini-css-extract-plugin
module.exports = {"h1":"style_h1__2ONf3","genericButton":"style_genericButton__1X__x","button":"style_button__15IWO","publish":"style_publish__1SX8M"};